import FillBlanks from "../../components/ClassOne/EnvironmentScience/MyFood/FillBlanks";
import IdentifyFoodItems from "../../components/ClassOne/EnvironmentScience/MyFood/IdentifyFoodItems";
import MatchFoodItems from "../../components/ClassOne/EnvironmentScience/MyFood/MatchFoodItems";
import OddOneOut from "../../components/ClassOne/EnvironmentScience/MyFood/OddOneOut";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/MyFood/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/my-need-food/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/my-need-food/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/my-need-food/match-food-items", title: "Match Food Items", component: MatchFoodItems },
    { url: "/class-one/environmental-science/my-need-food/odd-one-out", title: "Odd One Out", component: OddOneOut },
    { url: "/class-one/environmental-science/my-need-food/identify-food-items", title: "Identify Food", component: IdentifyFoodItems },
];

export default topics;